import { useTranslation } from 'react-i18next';
import React from "react";
import { Form, InputNumber, Tooltip } from "antd";

export const __FormInputNumber = ({ placeholder, fieldLabel, fieldName, ...props }) => {
    const { t } = useTranslation()
    const title = <span style={{ cursor: "pointer" }} onClick={(e) => {
        e.stopPropagation();
        if (props.copyText) {
            props.copyText(fieldName)
        }
    }}> {t(`erpcomponents.item.FormNumber.复制`)}</span>

    return (
        <Form.Item
            label={<Tooltip title={title}>{fieldLabel}</Tooltip>}
            name={fieldName}
            rules={props.rules}
            hidden={props.hidden}
            labelCol={props.labelCol}

        >

            <InputNumber
                disabled={props.disable}
                style={{ width: "100%" }}
                min={0}
                step={1}
                allowClear={props.allowClear}
                placeholder={placeholder ? placeholder : typeof fieldLabel === "string" ? fieldLabel : ""}
                onBlur={() => props.onInputBlur?.(fieldName)}
                precision={2} />

        </Form.Item>
    )
}